import type { PropType } from 'virtual-vue';
import type { FormRules, FormTrigger, FormLayout, FormLabelAlign, ValidateMessages } from './types';

export const props = {
  /**
   * 表单数据对象，由用户维护的 reactive 对象
   */
  model: {
    type: Object as PropType<Record<string, any>>,
  },

  /**
   * 表单初始值，resetFields 时回填此值到 model
   */
  initialValues: {
    type: Object as PropType<Record<string, any>>,
  },

  /**
   * 表单级校验规则（按字段名索引）
   */
  rules: {
    type: Object as PropType<FormRules>,
  },

  /**
   * 全局校验触发时机
   * @default 'onBlur'
   */
  validateTrigger: {
    type: [String, Array] as PropType<FormTrigger | FormTrigger[]>,
    default: 'onBlur',
  },

  /**
   * 某一个字段校验失败时是否停止剩余字段校验
   * @default false
   */
  validateFirst: {
    type: Boolean,
    default: false,
  },

  /**
   * 校验文案模板，支持 ${label} 占位符
   */
  validateMessages: {
    type: Object as PropType<ValidateMessages>,
  },

  /**
   * 是否显示错误文案
   * @default true
   */
  showErrorMessage: {
    type: Boolean,
    default: true,
  },

  /**
   * 全局标签宽度
   */
  labelWidth: {
    type: [String, Number] as PropType<string | number>,
  },

  /**
   * 全局标签对齐
   * @default 'left'
   */
  labelAlign: {
    type: String as PropType<FormLabelAlign>,
    default: 'left',
  },

  /**
   * 全局布局方式
   * @default 'horizontal'
   */
  layout: {
    type: String as PropType<FormLayout>,
    default: 'horizontal',
  },

  /**
   * 全局禁用
   * @default false
   */
  disabled: {
    type: Boolean,
    default: false,
  },

  /**
   * 全局只读
   * @default false
   */
  readonly: {
    type: Boolean,
    default: false,
  },
};
